import React from "react";
import styles from "../devicebackup.module.scss";
import { Collapse } from "antd";

interface ActionStatusSummary {
  level: string;
  event: any;
  statusResult: any;
  statusResultByCid: any;
}

const { Panel } = Collapse;

/* 用於顯示操作狀態的摘要資訊。
   它接受 "level"（權限層級）、
   "event"（操作事件數據）、
   "statusResult"（操作狀態統計）和 "statusResultByCid"（根據客戶 ID 分組的操作狀態統計）
   作為參數。*/
const ActionListSummary = React.memo(({ level, event, statusResult, statusResultByCid }: ActionStatusSummary) => {
  if (level !== "super_super") {
    return (
      <div style={event?.length ? { display: "flex" } : { display: "none" }} className={styles.actionDescription}>
        <p key={"total"}>
          {"TOTAL"}: {event?.length}
        </p>
        {Object.keys(statusResult).map((item, index) => {
          return (
            <p key={index}>
              {item}: {statusResult[`${item}`]}
            </p>
          );
        })}
      </div>
    );
  }
  return (
    <Collapse ghost style={event?.length ? { display: "flex" } : { display: "none" }}>
      <Panel
        key="status"
        header={
          <div style={{ display: "flex" }} className={styles.actionDescription}>
            <p key={"total"}>
              {"TOTAL"}: {event?.length}
            </p>
            {Object.keys(statusResult).map((item, index) => {
              return (
                <p key={index}>
                  {item}: {statusResult[`${item}`]}
                </p>
              );
            })}
          </div>
        }
      >
        {Object.keys(statusResultByCid).map((item, index) => {
          let str = "";
          Object.keys(statusResultByCid[item]).forEach((status) => {
            str += `  ${status}: ${statusResultByCid[item][status]}  `;
          });
          return (
            <div style={{ display: "flex", marginBottom: "10px", color: "gray", fontSize: "0.9rem" }} key={index}>
              {item} : {str}
            </div>
          );
        })}
      </Panel>
    </Collapse>
  );
});

export default ActionListSummary;
